import { OrgPricingResponse } from '@goldcast/api/backend';
import logger from '@goldcast/logger';

import { getEnv } from '@/utils/env';

export function initDriftBot(orgPricingConfig: OrgPricingResponse, userData: any) {
  const driftEnabled = getEnv('VUE_APP_DRIFT_ENABLED') === 'true';
  const driftBotKey = getEnv('VUE_APP_DRIFT_KEY');

  if (!driftEnabled || !driftBotKey) {
    logger.warn('Drift bot is disabled in this environment');
    return;
  }

  if (!window.drift) {
    logger.error('Drift bot is not loaded');
    return;
  }

  // eslint-disable-next-line no-console
  console.log('Calling drift.identify');
  window.drift.identify(userData.id, {
    name: userData.first_name.concat(' ', userData.last_name).trim() || undefined,
    email: userData.email,
    gc_pricing_tier_name: orgPricingConfig.tier
  });

  // eslint-disable-next-line no-console
  console.log('Calling drift.load');
  window.drift.load(driftBotKey);
}

export function resetDriftBot() {
  if (window.drift && typeof window.drift.unload === 'function') {
    // eslint-disable-next-line no-console
    console.log('Calling drift.unload');
    window.drift.unload();
  }

  if (window.drift && typeof window.drift.reset === 'function') {
    // eslint-disable-next-line no-console
    console.log('Calling drift.reset');
    window.drift.reset();
  }
}
